import http from "@/common/http-common";
import store from "@/store";

class EmoTemplateService {
  async loadAll() {
    return http().get("/api/v1/emo_templates.json").then(function(resp) {
      console.log("Inside EmoTemplateService.loadAll, resp.data ==> ", resp.data);
      const emoTemplates = resp.data.map(function(emoTemplateJson) {
        let tpl = emoTemplateJson;
        tpl.saving_method = (emoTemplateJson.saving_method) ? parseInt(emoTemplateJson.saving_method) : null;
        tpl.saving_pcn = (emoTemplateJson.saving_pcn) ? parseFloat(emoTemplateJson.saving_pcn) : null;
        return tpl;
      })
      //store.commit("updateEmoTemplates", resp.data);
      store.commit("updateEmoTemplates", emoTemplates);
    })

  }
}

export default new EmoTemplateService();